import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from 'store/store';
import { Provider } from 'react-redux';
import { initializeClevertap } from 'utils/analytics';
import { initializeSentry, updateSentryUserContext } from 'config/sentry';

// Initialize Sentry before anything else
initializeSentry();

// Set initial Sentry context from any persisted state
const initialState = store.getState();
if (initialState?.rootReducer?.app) {
  const { userDetails, currentTeam } = initialState.rootReducer.app;
  updateSentryUserContext(userDetails, currentTeam);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
initializeClevertap();
